import * as yup from "yup";

const invitePatientSchema = yup.object().shape({
  patientEmail: yup
    .string()
    .email("Enter a valid email")
    .required("Email must not be blank"),
});

export default invitePatientSchema;
